import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { NoSSR } from "@faire/web--source/common/NoSSR";
import { SVGIcon } from "@faire/web--source/slate/icons/SVGIcon";
import React from "react";
import { Suspense } from "react";
import { DeferRenderedQuickAddBase } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/Search/__internal__/DeferRenderedQuickAddBase";
/**
 * This component is used on product with brand tiles for
PERSIST_QUICK_ADD_ON_SEARCH_TILE_241029 xp.
 */ export var DeferRenderedQuickAdd = function(param) {
    var data = param.data;
    return /*#__PURE__*/ _jsx(NoSSR, {
        serverRenderFallback: /*#__PURE__*/ _jsx(QuickAddPlaceholder, {}),
        children: /*#__PURE__*/ _jsx(Suspense, {
            fallback: /*#__PURE__*/ _jsx(QuickAddPlaceholder, {}),
            children: /*#__PURE__*/ _jsx(DeferRenderedQuickAddBase, {
                data: data
            })
        })
    });
};
var QuickAddPlaceholder = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "absolute bottom-0 right-0 p-[8px]",
        children: /*#__PURE__*/ _jsx("div", {
            className: "bg-core-surface-inverse flex h-[32px] w-[32px] items-center justify-center rounded-full p-1",
            children: /*#__PURE__*/ _jsxs(SVGIcon, {
                color: Core.text.primary,
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12 1.71429V22.2857",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M1.71436 12H22.2858",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        })
    });
};
